export default __webpack_public_path__ + "img/WF.6ec29fa238b9d1dc38a0c41a21935ba7.jpg";